exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-column-wrapper[data-v-5e282bda]{width:100%;padding-bottom:10px}", ""]);

// exports
